import { ChakraBox as Box } from "@airhelp/react-ui-components";
import styles from "./Checklist.styles";
import type { ChecklistProps } from "./CheckList.d";

const Checklist = ({ props: content = "" }: ChecklistProps) => {
  if (!content) return null;

  let html = content;
  if (Array.isArray(html)) {
    html = html.join("");
  }

  return <Box backgroundColor="neutral.100" sx={styles} borderRadius="md" dangerouslySetInnerHTML={{ __html: html }} />;
};

export default Checklist;
